module.exports = __webpack_public_path__ + "static/media/cloud-sleet.5c22ee95.svg";